import React from "react";
import { Tab } from "react-bootstrap";
import {
  noDataFound,
  splitDateSlash,
} from "../../CommonMethhods/CommonMethods";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import Loader from "../../Components/Common/Loader";

function ClientMasterTab(props) {
  const {
    clientMaster,
    handleScrollClientMaster,
    forUpdateMaster,
    clientScrollLoader,
    mainClientLoader,
    clientNotFound,
  } = props;

  function UpdateClientMaster(data) {
    forUpdateMaster(data);
  }

  const ClientListDataMap = (clientMaster) => {
    return (
      clientMaster &&
      clientMaster.map((value, key) => {
        let { apCode, clientName, clientCode, brokerage } = value;
        return (
          <tr key={key}>
            <td>{apCode || "-"}</td>
            <td>{clientName || "-"}</td>
            <td>{clientCode || "-"}</td>
            <td>{brokerage?.modules?.sharing}%</td>
            <td>{brokerage?.modules?.del}%</td>
            <td>{brokerage?.modules?.future}%</td>
            <td>₹ {brokerage?.modules?.nifty}</td>
            <td>₹ {brokerage?.modules?.bankNifty}</td>
            <td>₹ {brokerage?.modules?.optionStock}</td>
            <td>{brokerage?.modules?.mName}</td>
            <td className="">{brokerage?.modules?.mRemarks || "-"}</td>
            <td>{brokerage?.modules?.mtflasROI}%</td>
            <td>{brokerage?.modules?.mtflasShare}%</td>
            <td>{splitDateSlash(brokerage?.modules?.modifiedDate) || "-"}</td>

            <td>
              <span
                className="icon-Edit edit-icon"
                onClick={() => UpdateClientMaster(value)}
              ></span>
            </td>
          </tr>
        );
      })
    );
  };

  return (
    <Tab.Pane eventKey="ClientMaster">
      {mainClientLoader ? (
        <div className="loader-alignment">
          <Loader />
        </div>
      ) : (
        <div className="scroll-table master_table clientmaster">
          <table className="table">
            <thead>
              <tr className="masterTableHead">
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col" colSpan="5" className="">
                  Base Brokerage Detail
                </th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col" className=""></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
              </tr>
              <tr>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col" colSpan="3">
                  Option
                </th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
              </tr>
              <tr>
                <th scope="col">AP Code</th>
                <th scope="col">Client Name</th>
                <th scope="col">Client Code</th>
                <th scope="col">AP Sharing</th>
                <th scope="col">Delivery</th>
                <th scope="col" className="">
                  Future/Cash Intraday
                </th>
                <th scope="col">Nifty</th>
                <th scope="col">Bank Nifty</th>
                <th scope="col">Option Stock</th>
                <th scope="col">Module</th>
                <th scope="col" className="">
                  Module Remarks
                </th>
                <th scope="col">MTF/LAS ROI</th>
                <th scope="col">MTF/LAS Sharing AP</th>
                <th scope="col">Modify Date</th>
                <th scope="col">Modify/Edit</th>
              </tr>
            </thead>
            {clientMaster && clientMaster.length > 0 ? (
              <tbody onScroll={handleScrollClientMaster} id="clientpageId">
                {ClientListDataMap(clientMaster)}
                {clientScrollLoader && (
                  <div className="loader-center">
                    <LoaderForSearch />
                  </div>
                )}
              </tbody>
            ) : (
              <tbody style={{ height: "100px" }} id="clientpageId">
                {clientNotFound && noDataFound()}
              </tbody>
            )}
          </table>
        </div>
      )}
    </Tab.Pane>
  );
}

export default ClientMasterTab;
